import { css } from '@emotion/react'

export const subtitle = css`
  text-align: center;
`
